// FETCH ALL PROPERTIES FROM KNITTING_DC DETAILS
export const FETCH_KNITTING_DC_DETAILS_REQUEST_DK = 'FETCH_KNITTING_DC_DETAILS_REQUEST_DK';
export const FETCH_KNITTING_DC_DETAILS_SUCCESS_DK = 'FETCH_KNITTING_DC_DETAILS_SUCCESS_DK';
export const FETCH_KNITTING_DC_DETAILS_FAILURE_DK = 'FETCH_KNITTING_DC_DETAILS_FAILURE_DK';

// FETCH ALL PROPERTIES FROM KNITTING_DC DETAILS BY ID
export const FETCH_KNITTING_DC_DETAILS_BY_ID_REQUEST_DK = 'FETCH_KNITTING_DC_DETAILS_BY_ID_REQUEST_DK';
export const FETCH_KNITTING_DC_DETAILS_BY_ID_SUCCESS_DK = 'FETCH_KNITTING_DC_DETAILS_BY_ID_SUCCESS_DK';
export const FETCH_KNITTING_DC_DETAILS_BY_ID_FAILURE_DK = 'FETCH_KNITTING_DC_DETAILS_BY_ID_FAILURE_DK';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_GRN_NO_BY_YARN_PO_REQUEST_DK = 'FETCH_GRN_NO_BY_YARN_PO_REQUEST_DK';
export const FETCH_GRN_NO_BY_YARN_PO_SUCCESS_DK = 'FETCH_GRN_NO_BY_YARN_PO_SUCCESS_DK';
export const FETCH_GRN_NO_BY_YARN_PO_FAILURE_DK = 'FETCH_GRN_NO_BY_YARN_PO_FAILURE_DK';

// CREATE PROPERTIES FOR KNITTING_DC DETAILS
export const CREATE_KNITTING_DC_DETAILS_REQUEST_DK = 'CREATE_KNITTING_DC_DETAILS_REQUEST_DK';
export const CREATE_KNITTING_DC_DETAILS_SUCCESS_DK = 'CREATE_KNITTING_DC_DETAILS_SUCCESS_DK';
export const CREATE_KNITTING_DC_DETAILS_FAILURE_DK = 'CREATE_KNITTING_DC_DETAILS_FAILURE_DK';

//CREATE USER FORM
export const CREATE_USER_FORM_KNITTING_DC_DETAILS_DK = 'CREATE_USER_FORM_KNITTING_DC_DETAILS_DK';

// UPDATE PROPERTIES FOR KNITTING_DC DETAILS
export const UPDATE_KNITTING_DC_DETAILS_REQUEST_DK = 'UPDATE_KNITTING_DC_DETAILS_REQUEST_DK';
export const UPDATE_KNITTING_DC_DETAILS_SUCCESS_DK = 'UPDATE_KNITTING_DC_DETAILS_SUCCESS_DK';
export const UPDATE_KNITTING_DC_DETAILS_FAILURE_DK = 'UPDATE_KNITTING_DC_DETAILS_FAILURE_DK';

// FETCH SINGLE KNITTING_DC_DETAILS
export const FETCH_SINGLE_KNITTING_DC_DETAILS_REQUEST_DK = 'FETCH_SINGLE_KNITTING_DC_DETAILS_REQUEST_DK';
export const FETCH_SINGLE_KNITTING_DC_DETAILS_SUCCESS_DK = 'FETCH_SINGLE_KNITTING_DC_DETAILS_SUCCESS_DK';
export const FETCH_SINGLE_KNITTING_DC_DETAILS_FAILURE_DK = 'FETCH_SINGLE_KNITTING_DC_DETAILS_FAILURE_DK';

// DELETE PROPERTIES FOR KNITTING_DC DETAILS
export const DELETE_KNITTING_DC_DETAILS_REQUEST_DK = 'DELETE_KNITTING_DC_DETAILS_REQUEST_DK';
export const DELETE_KNITTING_DC_DETAILS_SUCCESS_DK = 'DELETE_KNITTING_DC_DETAILS_SUCCESS_DK';
export const DELETE_KNITTING_DC_DETAILS_FAILURE_DK = 'DELETE_KNITTING_DC_DETAILS_FAILURE_DK';

export const FETCH_KNITTING_DC_PREVIOUS_LIST_REQUEST_DK = 'FETCH_KNITTING_DC_PREVIOUS_LIST_REQUEST_DK';
export const FETCH_KNITTING_DC_PREVIOUS_LIST_SUCCESS_DK = 'FETCH_KNITTING_DC_PREVIOUS_LIST_SUCCESS_DK';
export const FETCH_KNITTING_DC_PREVIOUS_LIST_FAILURE_DK = 'FETCH_KNITTING_DC_PREVIOUS_LIST_FAILURE_DK';

// USERFORM RESET

export const KNITTING_DC_DETAILS_USERFORM_RESET_DK = 'KNITTING_DC_DETAILS_USERFORM_RESET_DK';

export const FETCH_FABRIC_BY_YARN_PO_REQUEST_DK = 'FETCH_FABRIC_BY_YARN_PO_REQUEST_DK';
export const FETCH_FABRIC_BY_YARN_PO_SUCCESS_DK = 'FETCH_FABRIC_BY_YARN_PO_SUCCESS_DK';
export const FETCH_FABRIC_BY_YARN_PO_FAILURE_DK = 'FETCH_FABRIC_BY_YARN_PO_FAILURE_DK';

export const KNITTING_CLOSE_BTN_POST_REQUEST = 'KNITTING_CLOSE_BTN_POST_REQUEST'
export const KNITTING_CLOSE_BTN_POST_SUCCESS = 'KNITTING_CLOSE_BTN_POST_SUCCESS'
export const KNITTING_CLOSE_BTN_POST_FALIURE = 'KNITTING_CLOSE_BTN_POST_FALIURE'



export const KNITTING_CHECK_ALL_UPDATE_REQUEST = 'KNITTING_CHECK_ALL_UPDATE_REQUEST'
export const KNITTING_CHECK_ALL_UPDATE_SUCCESS = 'KNITTING_CHECK_ALL_UPDATE_SUCCESS'
export const KNITTING_CHECK_ALL_UPDATE_FALIURE = 'KNITTING_CHECK_ALL_UPDATE_FALIURE'
